import { all } from 'redux-saga/effects';

import moSagas from '@/online-merchant-onboarding/sagas';

import loginSaga from './loginSagas';
import merchantDetailsSaga from './merchantDetailsSaga';
import initSaga from './initSagas';
import storeSaga from './manageStoreSaga';
import userApiSaga from './userApiSaga';
import chatBotSaga from './chatBotSaga';
import userProfileSaga from './userProfileSagas';
import userConfigSaga from './userConfigSagas';

export default function* rootSaga() {
	yield all([
		initSaga(),
		loginSaga(),
		merchantDetailsSaga(),
		storeSaga(),
		userApiSaga(),
		chatBotSaga(),
		userProfileSaga(),
		userConfigSaga(),
		...moSagas,
	]);
}
